import styled from 'styled-components'

export const CreateCampaignWrapper = styled.div`
  .button-back {
    display: block;
    float: left;
    margin: 23px 20px 0 0;
  }

  .page-title {
    display: block;
    float: left;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Campaigns/CreateEditCampaign/CreateEditCampaignWrapper/index.js